import { LanguageContext, TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { Card, CardContent, Grid, GridColumn } from 'telia-front-react';
import InternetOfferCard from '../card/InternetOfferCard';
import { useInternetEditOffers } from '../edit/InternetEditProvider';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { useInternetOffers } from '../InternetOffersProvider';
import GravityFormWrapper from './GravityFormWrapper';
export const InternetForm = (props) => {
    var _a, _b, _c;
    const { translate } = React.useContext(TranslationsContext);
    const { lang } = React.useContext(LanguageContext);
    const { isMobile } = useIsMobileHook();
    const { calculatorState } = useInternetOffers();
    const { address, room } = useInternetEditOffers();
    const { auth, internetCalculatorConfigState } = useInternetCalculator();
    const { offer, manuallySetFormType } = props;
    const isEditCalculator = !!address;
    const offerNameForAnalytics = (offer === null || offer === void 0 ? void 0 : offer.productOfferingCode) || 'Kiirema interneti sooviavaldus';
    const formType = (_a = offer === null || offer === void 0 ? void 0 : offer.salesChannel) !== null && _a !== void 0 ? _a : manuallySetFormType;
    const formName = (_c = (_b = internetCalculatorConfigState.config) === null || _b === void 0 ? void 0 : _b.formNamesBySalesChannel[formType]) === null || _c === void 0 ? void 0 : _c[lang];
    const isPartnerOrPlannedSecureNetOffer = (offer === null || offer === void 0 ? void 0 : offer.properties.includes('PARTNER')) || ((offer === null || offer === void 0 ? void 0 : offer.properties.includes('SECURE_NET')) && offer.properties.includes('PLANNED'));
    const resolveFieldValueProviders = () => {
        var _a, _b, _c, _d, _e;
        return [
            {
                data: isEditCalculator ? address === null || address === void 0 ? void 0 : address.label : calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.address.label,
                fixedValue: true,
                technicalParameter: 'internet_address'
            },
            {
                data: isEditCalculator ? room === null || room === void 0 ? void 0 : room.roomName : (_a = calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.room) === null || _a === void 0 ? void 0 : _a.roomName,
                fixedValue: true,
                technicalParameter: 'internet_room'
            },
            {
                data: isEditCalculator ? address === null || address === void 0 ? void 0 : address.id : calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.address.id,
                fixedValue: true,
                technicalParameter: 'internet_address_id'
            },
            {
                data: isEditCalculator ? address === null || address === void 0 ? void 0 : address.buildingId : calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.address.buildingId,
                fixedValue: true,
                technicalParameter: 'internet_building_id'
            },
            {
                data: isEditCalculator ? room === null || room === void 0 ? void 0 : room.roomId : ((_c = (_b = calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.room) === null || _b === void 0 ? void 0 : _b.roomId) !== null && _c !== void 0 ? _c : ''),
                fixedValue: true,
                technicalParameter: 'internet_apartment_id'
            },
            {
                data: translate('internetCalculator.requestForm.speedSummary', {
                    downloadSpeed: (_d = offer === null || offer === void 0 ? void 0 : offer.downloadSpeed) !== null && _d !== void 0 ? _d : '',
                    uploadSpeed: (_e = offer === null || offer === void 0 ? void 0 : offer.uploadSpeed) !== null && _e !== void 0 ? _e : ''
                }),
                fixedValue: true,
                technicalParameter: 'internet_speed'
            }
        ];
    };
    return (React.createElement(Grid, null,
        React.createElement(GridColumn, null,
            React.createElement(Card, { padding: isMobile ? 'small' : 'medium' },
                React.createElement(CardContent, { background: "neutral-bg-level-2" },
                    React.createElement(Grid, { align: ['center-xs'] },
                        isPartnerOrPlannedSecureNetOffer && (React.createElement(GridColumn, { width: ['xs-12', 'sm-5', 'md-4', 'lg-3'] },
                            React.createElement(InternetOfferCard, { inModal: true, inForm: true, hideButtons: true, offer: offer }))),
                        React.createElement(GridColumn, { width: isPartnerOrPlannedSecureNetOffer ? ['xs-12', 'sm-7', 'md-8', 'lg-9'] : ['xs-12'] },
                            React.createElement(GravityFormWrapper, { clientAuth: auth, credentialsAllowed: true, showTitle: false, showDescription: false, name: formName, fieldValueProviders: resolveFieldValueProviders(), submitButtonProps: {
                                    className: 'text__margin-double',
                                    type: 'primary',
                                    block: isMobile
                                }, submissionCustomGaData: { eventLabel: `CTA - Modal submit - ${offerNameForAnalytics}`, eventCategory: 'Internet' } }))))))));
};
